module.exports = __webpack_public_path__ + "static/media/loader.e30d9b7b.gif";